import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./FanClub.module.scss";
import Dardanet from "../../assets/images/Dardanet.png";

const FanClub = () => {
  const { t } = useTranslation();

  return (
      <div className={styles.MainWrapper}>
        <div className={styles.ListWrapper}>
          <div className={styles.DardanetContainer}>
            <h1>{t("fanclub.title")}</h1>
            <a
                href="https://www.facebook.com/dardanetks/"
                target="_blank"
                rel="noopener noreferrer"
            >
              <img
                  src={Dardanet}
                  alt="Kosovo"
                  style={{ cursor: "pointer", width: "100%" }}
              />
            </a>
            <p>{t("fanclub.paragraph1")}</p>
            <br />
            <p>{t("fanclub.paragraph2")}</p>
            <br />
            <p>{t("fanclub.paragraph3")}</p>
          </div>
        </div>
      </div>
  );
};

export default FanClub;
